import {ErrorMessage, Field} from 'formik';
import {useLocation} from 'react-router-dom';

import {Box, SxProps, Typography, useTheme} from '@mui/material';

import {EmpionSelectField} from '../../../../../../../../components/EmpionSelectField/EmpionSelectField';
import {greenColors, orangeColors} from '../../../../../../../../layouts/theme/designSystem';
import {isQuestionnairePage} from '../../../../../../../../utils/questionnaireUtils/isQuestionnairePage';

interface SelectFieldQuestionnaireProps {
  label: string;
  options: any[];
  name: string;
}

export const SelectFieldQuestionnaire = ({label, options, name}: SelectFieldQuestionnaireProps) => {
  const theme = useTheme();

  const currentPage = useLocation();
  const {pathname} = currentPage;

  const isQuestionnairePageStyles: SxProps = {
    borderRadius: '4px',
    backgroundImage: 'none',
    '& .MuiOutlinedInput-root': {
      backgroundColor: orangeColors[4],
      color: greenColors[700],
      '&:hover': {
        backgroundColor: orangeColors[4],
      },
      '& fieldset': {
        borderColor: orangeColors[4],
      },
      '&:hover fieldset': {
        borderColor: orangeColors[4],
      },
      '&.Mui-focused fieldset': {
        borderColor: orangeColors[4],
      },
      '& .MuiOutlinedInput-input': {
        caretColor: theme.palette.text.primary,
      },
    },
    '& .MuiInputLabel-root': {
      color: theme.palette.text.primary,
      '&.Mui-focused': {
        color: theme.palette.text.primary,
      },
    },
    '& .Mui-selected': {
      backgroundColor: greenColors[40],
    },
  };

  return (
    <Box
      sx={{
        width: {xs: '100%', sm: '400px'},
      }}
    >
      <Typography variant='h4' color={greenColors[700]} gutterBottom>
        {label}
      </Typography>

      <Field
        type='select'
        name={name}
        component={EmpionSelectField}
        options={options}
        size={'small'}
        id={name}
        sx={isQuestionnairePage(pathname) ? isQuestionnairePageStyles : {}}
        isQuestionnairePage={isQuestionnairePage(pathname)}
      />
      <Typography variant='body2' color='error' marginTop={1}>
        <ErrorMessage name={name} component='span' />
      </Typography>
    </Box>
  );
};
